import { isNil } from 'lodash';

export function extractErrorMessage(error: any): string;
export function extractErrorMessage(
  error: any,
  disableDefault: true,
): string | null;
export function extractErrorMessage(...args: any[]): any {
  const error = args[0];
  const disableDefault = Boolean(args[1]) ?? false;
  if (!isNil(error)) {
    if (typeof error === 'string') return error;
    if (typeof error === 'object') {
      if (Array.isArray(error)) {
        for (const e of error) {
          const msg = extractErrorMessage(e, true);
          if (msg) return msg;
        }
      } else if ('message' in error) {
        return extractErrorMessage(error.message);
      }
    }
  }
  return disableDefault ? null : 'generic';
}
